backend_url = "https://backend.stage.nasta.fr"
frontend_url = "https://app.stage.nasta.fr"

export default
    # ## General
    backend_url: backend_url
    frontend_url: frontend_url
    graphql_url: backend_url+"/graphql/"
    media_url: backend_url+"/media/"
    document_url: backend_url+"/document/print/"
    # ## core app
    login_url: backend_url+"/core/auth/login/"
    logout_url: backend_url+"/core/auth/logout/"
    lost_password_url: backend_url+"/core/auth/lost_password/"
    change_password_url: backend_url+"/core/auth/change_password/"
    # ## app_user app
    change_is_active: backend_url+"/app_user/change_active/"
    change_is_archived: backend_url+"/app_user/change_archived/"
    users_stats: backend_url+"/app_user/users_stats/"
    exports: backend_url+"/app_user/exports/"
    resend_activation_email: backend_url+"/app_user/resend_activation_email/"
    revive_interview: backend_url+"/app_user/revive_interview/"
    # ## company app
    change_active: backend_url+"/company/change_active/"
    import_first_lines: backend_url+"/company/import_first_lines/"
    imports: backend_url+"/company/imports/"
    vpe_zipfile: backend_url+"/company/vpe_zipfile/"
    send_or_close_vpe: backend_url+"/company/send_or_close_vpe/"
    reset_vpduj: backend_url+"/company/reset_vpduj/"
    accounting_software_import: backend_url+"/company/accounting_software_import/"
    file_upload_url: backend_url+"/core/upload_file/"
    file_list_url: backend_url+"/core/list_files/"
    file_delete_url: backend_url+"/core/delete_file/"
